import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-body-2 mb-3" }

import { computed, ref, watch } from "vue";
import SelectorEjercito from "./SelectorEjercito.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalElegirEjercito',
  props: {
    isVisible: { type: Boolean },
    titulo: {},
    ejercitoActual: {},
    texto: {}
  },
  emits: ["update:isVisible", "confirm"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const visible = computed({
  get: () => props.isVisible,
  set: valor => emit("update:isVisible", valor),
});

const ejercito = ref<string | null>(props.ejercitoActual ?? null);

watch(
  () => props.isVisible,
  abierto => {
    if (abierto) ejercito.value = props.ejercitoActual ?? null;
  }
);

const confirmar = () => {
  if (!ejercito.value) return;
  emit("confirm", ejercito.value);
  visible.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: visible.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((visible).value = $event)),
    "max-width": "480"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "text-wrap" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.titulo), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.texto ??
            "En la liga llevas este ejército en todas tus partidas. Puedes cambiar de lista en cada jornada, pero siempre de este ejército."), 1),
              _createVNode(SelectorEjercito, {
                modelValue: ejercito.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((ejercito).value = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                color: "grey",
                variant: "text",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (visible.value = false))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Cancelar ")
                ]),
                _: 1
              }),
              _createVNode(_component_v_btn, {
                color: "primary",
                variant: "tonal",
                disabled: !ejercito.value,
                onClick: confirmar
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Confirmar ")
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})